<template>
  <router-view></router-view>
</template>
<script>
//https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh;
function setVH() {
  vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
}
// Then we set the value in the --vh custom property to the root of the document
setVH();

window.addEventListener("orientationchange", setVH);
// window.addEventListener("resize", setVH);
</script>
<style></style>



// WEBPACK FOOTER //
// src/App.vue